import {Route, Routes} from "react-router-dom";
import {RouteHelper, RouteInfo} from "../route/RouteHelper";
import "./ContainerStyleSheet.scss"
import Header from "../component/Header/Header";
import Profile from "../pages/profile/Profile";
import ReleaseDocuments from "../pages/releaseDocuments/ReleaseDocuments";
import Dashboard from "../pages/dashboard/Dashboard";
import React from 'react';
import ManagersList from "../pages/managersList/ManagersList";
import {ManagerDetail} from "../pages/managerDetail/ManagerDetail";
import SimpleBarChart from "../pages/./charts/SimpleBarChart";
import PieChartWithPaddingAngle from "../pages/./charts/PieChartWithPaddingAngle";
import VerticalBarChart from "../pages/./charts/VerticalBarChart";
import DoughnutChart from "../pages/./charts/DoughnutChart";
import PieChart from "../pages/./charts/PieChart";
import SimplePieChart from "../pages/./charts/SimplePieChart";
import MagazineList from "../pages/magazine/MagazineList";
import MagazineDetail from "../pages/magazine/MagazineDetail";
import MagazineCategory from "../pages/magazineCategory/MagazineCategory";
import FileManager2 from "../pages/fileManager2/FileManager2";
import TagsList from "../pages/tagList/TagsList";
import MagazineWriters from "../pages/magazineWriters/MagazineWriters";
import MagazineWriterDetail from "../pages/magazineWriters/MagazineWriterDetail";
import NotFound from "../pages/notFound/NotFound";
import NotAccess from "../pages/notAccess/NotAccess";
import {FileManagerTypes} from "../component/fileManager/FileManager";
import PaymentGatewaysList from "../pages/paymentGatewaysList/PaymentGatewaysList";
import PaymentGatewayInformation from "../component/paymentGateway/paymentGatewayInformation/PaymentGatewayInformation";
import {TransactionsList} from "../pages/transactions/TransactionsList";
import UsersList from "../pages/usersList/UsersList";
import UserInformation from "../pages/userInfromation/UserInformation";
import UsersStatistics from "../pages/userInfromation/UsersStatistics";
import {TransactionDetail} from "../pages/transactions/TransactionDetail";
import FundSuperAdmin from "../pages/funds/FundSuperAdmin";
import FundList from "../pages/funds/FundList";
import FundDetail from "../pages/funds/fundDetail/FundDetail";
import Union from "../pages/union/Union";
import UnionDetail from "../pages/union/UnionDetail";
import FundsAdmins from "../pages/fundsAdmins/FundsAdmins";
import FundAdminDetail from "../pages/fundsAdmins/detail/FundAdminDetail";
import ContactUs from "../pages/contactUs/ContactUs";
import Sliders from "../pages/sliders/Sliders";
import SliderDetail from "../pages/sliders/SliderDetail";
import Features from "../pages/features/Features";
import FeatureDetail from "../pages/features/FeatureDetail";
import NewsList from "../pages/news/NewsList";
import SiteCharts from "../pages/siteCharts/SiteCharts";
import SiteChartsDetail from "../pages/siteCharts/SiteChartsDetail";
import NotificationsList from "../pages/notificationsList/NotificationsList";
import NotificationDetail from "../pages/notificationsList/NotificationDetail";
import Setting from "../pages/setting/Setting";
import Projects from "../pages/projects/Projects";
import VersionControl from "../pages/versionControl/VersionControl";
import Forms from "../pages/forms/Forms";
import FormDetail from "../pages/forms/FormDetail";
import Videos from "../pages/videos/Videos";
import NewsDetail from "../pages/news/NewsDetail";
import VideoDetail from "../pages/videos/VideoDetail";
import ProjectDetail from "../pages/projects/ProjectDetail";


const Container = () => {

    return (
        <section
            className={"basePageContainer"}>
            <div className={"baseHeaderContainer"}>
                <Header/>
            </div>

            <section className={`basePageContentContainer`}>
                <Routes>
                    <Route path={RouteInfo.Profile.url} element={<Profile/>}/>

                    <Route path={RouteInfo.ReleaseDocuments.url} element={<ReleaseDocuments/>}/>
                    <Route path={RouteInfo.Files.url} element={<FileManager2/>}/>

                    <Route path={RouteInfo.Managers.url} element={<ManagersList/>}/>
                    <Route path={RouteInfo.ManagersDetail.url} element={<ManagerDetail/>}/>


                    <Route path={RouteHelper.Union.url} element={<Union/>}/>
                    <Route path={RouteHelper.UnionDetail.url} element={<UnionDetail/>}/>

                    <Route path={RouteHelper.ContactUs.url} element={<ContactUs/>}/>

                    <Route path={RouteHelper.Features.url} element={<Features/>}/>
                    <Route path={RouteHelper.FeatureDetail.url} element={<FeatureDetail/>}/>

                    <Route path={RouteInfo.Dashboard.url} element={<Dashboard/>}/>

                    <Route path={RouteInfo.MagazineList.url} element={<MagazineList/>}/>
                    <Route path={RouteInfo.MagazineCategory.url} element={<MagazineCategory/>}/>
                    <Route path={RouteHelper.TagList.url} element={<TagsList/>}/>

                    <Route path={RouteHelper.MagazineProjects.url} element={<Projects/>}/>
                    <Route path={RouteHelper.MagazineProjectsDetail.url} element={<ProjectDetail/>}/>


                    <Route path={RouteHelper.Forms.url} element={<Forms/>}/>
                    <Route path={RouteHelper.FormDetail.url} element={<FormDetail/>}/>

                    <Route path={RouteHelper.MagazineSlider.url} element={<Sliders/>}/>
                    <Route path={RouteHelper.MagazineSliderDetail.url} element={<SliderDetail/>}/>

                    <Route path={RouteHelper.MagazineVideos.url} element={<Videos/>}/>
                    <Route path={RouteHelper.MagazineVideoDetail.url} element={<VideoDetail/>}/>

                    <Route path={RouteHelper.MagazineNews.url} element={<NewsList/>}/>
                    <Route path={RouteHelper.MagazineNewsDetail.url} element={<NewsDetail/>}/>

                    <Route path={RouteHelper.NotificationsList.url} element={<NotificationsList/>}/>
                    <Route path={RouteHelper.NotificationsDetail.url} element={<NotificationDetail/>}/>

                    <Route path={RouteHelper.Setting.url} element={<Setting/>}/>

                    <Route path={RouteHelper.MagazineCharts.url} element={<SiteCharts/>}/>
                    <Route path={RouteHelper.MagazineChartDetail.url} element={<SiteChartsDetail/>}/>

                    <Route path={RouteHelper.FileManager.url}
                           element={
                               <FileManager2
                                   buckets={[
                                       FileManagerTypes.NEWS_THUMBNAILS,
                                       FileManagerTypes.PROJECT_IMAGES,
                                   ]}
                               />}/>

                    <Route path={RouteInfo.MagazineDetail.url} element={<MagazineDetail/>}/>
                    <Route path={RouteHelper.MagazineWriters.url} element={<MagazineWriters/>}/>
                    <Route path={RouteHelper.MagazineWriterDetail.url} element={<MagazineWriterDetail/>}/>


                    {/*<Route path={RouteInfo.SimpleBarChart.url} element={<SimpleBarChart/>}/>*/}
                    {/*<Route path={RouteInfo.PieChartWithPaddingAngle.url} element={<PieChartWithPaddingAngle/>}/>*/}
                    {/*<Route path={RouteInfo.VerticalBarChart.url} element={<VerticalBarChart/>}/>*/}
                    {/*<Route path={RouteInfo.SimplePieChart.url} element={<SimplePieChart/>}/>*/}
                    {/*<Route path={RouteInfo.DoughnutChart.url} element={<DoughnutChart/>}/>*/}
                    {/*<Route path={RouteInfo.PieChart.url} element={<PieChart/>}/>*/}


                    <Route path={RouteHelper.PaymentGatewaysList.url} element={<PaymentGatewaysList/>}/>
                    <Route path={RouteHelper.PaymentGatewaysInformation.url} element={<PaymentGatewayInformation/>}/>


                    <Route path={RouteHelper.TransactionsList.url} element={<TransactionsList/>}/>
                    <Route path={RouteHelper.TransactionDetail.url} element={<TransactionDetail/>}/>

                    <Route path={RouteHelper.UsersList.url} element={<UsersList/>}/>
                    <Route path={RouteHelper.UserInformation.url} element={<UserInformation/>}/>
                    <Route path={RouteHelper.UsersStatistics.url} element={<UsersStatistics/>}/>


                    <Route path={RouteHelper.FundsSuperAdmin.url} element={<FundSuperAdmin/>}/>
                    <Route path={RouteHelper.FundDetail.url} element={<FundDetail/>}/>
                    <Route path={RouteHelper.FundsList.url} element={<FundList/>}/>

                    <Route path={RouteHelper.FundAdminsList.url} element={<FundsAdmins/>}/>
                    <Route path={RouteHelper.FundAdminDetail.url} element={<FundAdminDetail/>}/>

                    <Route path={RouteHelper.VersionControl.url} element={<VersionControl/>}/>

                    <Route path="/403" element={<NotAccess/>}/>
                    <Route path={'/'} element={<Dashboard/>}/>
                    <Route path="/*" element={<NotFound/>}/>
                </Routes>
            </section>
            {/*<section className={css`*/}
            {/*  width: 100%;*/}
            {/*  padding: .5rem;*/}
            {/*  display: flex;*/}
            {/*  align-items: center;*/}
            {/*  justify-content: center;*/}
            {/*`}>*/}
            {/*    <CopyRightLinkRaiko/>*/}
            {/*</section>*/}

        </section>
    )
}
export default Container